import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

export const PrivateRoutes = () => {
    let token = Cookies.get(`${process.env.NODE_ENV}-userToken`);
    if (!token) {
        console.log("here not logged")
        localStorage.removeItem(`${process.env.NODE_ENV}-userToken`);
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};